import React from "react";

const AnimatedText = ({ text }) => {
  return (
    <div class="animateText">
      <svg style={{ width: "100%", height: "60px" }}>
        <text x="50%" y="50%" dy=".35em" text-anchor="middle">
          Admin Panel
        </text>
      </svg>
    </div>
  );
};

export default AnimatedText;
